<template>
    <div class="lfmpub-form__box">
        <div class="lfmpub-form__box-header h5 text-primary text-center">{{ header }}</div>
        <div class="lfmpub-form__box-content">
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
defineProps({
    header: { type: String, required: true },
});
</script>
